import timezone from 'dayjs/plugin/timezone' // import plugin
import utc from 'dayjs/plugin/utc' // import plugin
import dayjs from 'dayjs'
dayjs.extend(timezone)
dayjs.extend(utc)

export default dayjs
export type { Dayjs } from 'dayjs'
